import Audio from "@frog/source/utility/Audio.js"

const audiotriggers = {
    // "Unit:Attack:Melee": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Attack_Melee.ogg")), // bad
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Attack_Melee.ogg")),
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 1.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 2.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 3.wav")),
    //     ]
    // },
    // "Unit:Attack:Ranged": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Attack_Ranged.ogg")), // bad
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Bo Staff Flip.wav")),
    // },
    // "Unit:Heal": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Heal.ogg")),
    // },
    // "Unit:Attack:FinalHit": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit_Kill.ogg")),
    // },
    // "Unit:Attack:NoDamage": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit_NoDamage.ogg")),
    // },
    // "Unit:Death": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Death.ogg")),
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CANNOT CONFIRM.wav")),
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Pull In.wav")),
    // },
    // "Unit:Move": {
    //     "volume": 0.33,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 1.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 2.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 3.wav")),
    //     ]
    // },
    "Selection:Start": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/map_4.wav")),
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Select.wav")),
        // "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/SELECT UNIT.wav")),
    },
    "Selection:Finish": {
        "volume": 0.33,
        // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Finish.ogg")), // bad
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/PerformAction.wav")),
        // "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CONFIRM.wav")),
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/map_4.wav")),
    },
    "Selection:Move": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/map_5.wav")),
        // "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CURSOR MOVEMENT.wav")),
    },
    "Selection:Cancel": {
        "volume": 0.22,
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/embedded_6.wav")),
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UnSelect.wav")),
        // "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CANCEL.wav")),
    },
    "EndTurn": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/embedded_5.wav")),
        // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Player_EndTurn.ogg")),
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CONFIRM (Generic).wav"))
        // "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/END TURN.wav")),
    },
    "UndoAction": {
        "volume": 0.4,
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/embedded_4.wav")),
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX TEXT WINDOW CLOSE 2.wav"))
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UndoAction.wav"))
        // "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/UNDO.wav")),
    },

    // "Start": {
    //     "volume": 0.37,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX TITLE SCREEN GAME START.wav")),
    // },
    // "xMusic:Title": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "kill": {"label": "music"},
    //
    //     "type": "sequence:march",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/good-music/FARM DAWN + INTRO FINAL.wav")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/good-music/FARM DAWN LOOPED.wav")),
    //     ],
    // },
    // "Music:Combat:LD54a": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "kill": {"label": "music"},
    //
    //     "type": "sequence:march",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/good-music/FARM DAWN + INTRO FINAL.wav")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/good-music/FARM DAWN LOOPED.wav")),
    //     ],
    // },
    // "Music:Combat:LD54b": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "kill": {"label": "music"},
    //
    //     "type": "sequence:march",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/good-music/FARM DUSK + INTRO FINAL.wav")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/good-music/FARM DUSK LOOPED.wav")),
    //     ],
    // },
    // "Music:Combat:LD54c": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "kill": {"label": "music"},
    //
    //     "type": "sequence:march",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/good-music/FARM NIGHT + INTRO FINAL.wav")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/good-music/FARM NIGHT LOOPED.wav")),
    //     ],
    // },
    // "Music:Combat:Done": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "kill": {"label": "music"},
    //     "audio": new Audio(require("@frog/source/assets/audio/borrowed/onepiece-overtaken.mp3")),
    // },
    // "Ember:Music:Combat": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "kill": {"label": "music"},
    //     "audio": new Audio(require("@frog/source/assets/audio/borrowed/httyd - forbidden friendship.mp3")),
    //     "loop": true,
    // },
    // "Ember:Music:Victory": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "kill": {"label": "music"},
    //     "audio": new Audio(require("@frog/source/assets/audio/borrowed/httyd - romantic flight.mp3")),
    // },
    // "Unit:Garden": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Garden.ogg")),
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Garden_FInal.ogg")), // bad
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Throw.wav")),
    // },
    // "Unit:Harvest": {
    //     "volume": 0.2,
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Crop_Harvest.ogg")),
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Harvest.ogg")), // bad
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CONFIRM (Generic).wav")),
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/powerup.wav")),
    // },
    // "Unit:Pig": {
    //     "volume": 0.1,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/cry1.wav")),
    // },
    // "Unit:Chicken": {
    //     "volume": 0.1,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/cry3.wav")),
    // },
    // "Unit:Sheep": {
    //     "volume": 0.1,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/cry2.wav")),
    // },

    // "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/PUSH GUN.wav")),
    // "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/PULL GUN.wav")),
    // "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/BOMB THROW.wav")),
    // "audio": [
    //     new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 1.wav")),
    //     new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 2.wav")),
    //     new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 3.wav")),
    //     new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 4.wav")),
    // ]
    // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Falling Off Map.wav"))
    // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Escape Map Zipline.wav"))
    //
    // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Fire.wav"))
    // "audio": [
    //     new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav")),
    //     new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav")),
    // ]
    // "Victory:Final": {
    //     "volume": 1,
    //     "type": "march",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Victory Theme ENDGAME.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Full.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Loop.wav")),
    //     ],
    //     "killTrigger": "Music:Final",
    // }


















    // "Music:Title": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Main_Menu_MX.ogg")),
    //     "kill": {"label": "music"},
    // },
    // "Music:Chill": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Intro.ogg")),
    //     "kill": {"label": "music"},
    // },

    // "Ambience:General": {
    //     "volume": 0.37,
    //     "label": "ambience",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Wasteland_Ambience_Final.ogg")),
    //     "kill": {"label": "ambience"},
    // },
    // "Ambience:Town": {
    //     "volume": 0.37,
    //     "label": "ambience",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Town_Ambience.ogg")),
    //     "kill": {"label": "ambience"},
    // },

    // "Unit:Death": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CANNOT CONFIRM.wav"))
    // },
    // "Unit:Death:Falling": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Falling Off Map.wav"))
    // },
    // "Unit:Escape": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Escape Map Zipline.wav"))
    // },
    // "Flipper:Swing": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Bo Staff Flip.wav"))
    //     ]
    // },
    // "Pusher:Swing": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 1.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 2.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 3.wav")),
    //     ]
    // },
    // "Robot:Swing": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Robot Sounds.wav"))
    //     ]
    // },
    // "Puller:Throw": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Throw.wav"))
    // },
    // "Puller:Pull": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Pull In.wav"))
    // },
    // "Aoe-er:Shoot": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Fire.wav"))
    // },
    // "Aoe-er:Explosion": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav")),
    //     ]
    // },
    // "Victory": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Victory Theme 1.wav"))
    //     ],
    // },
    // "Victory:Final": {
    //     "volume": 1,
    //     "type": "march",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Victory Theme ENDGAME.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Full.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Loop.wav")),
    //     ],
    //     "killTrigger": "Music:Final",
    // }
    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Select.wav")),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UnSelect.wav")),
    // },
    // "Selection:Finish": {
    //     "volume": 0.85,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/PerformAction.wav")),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Hover.wav")),
    // },
    // "EndTurn": {
    //     "volume": 0.85,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CONFIRM (Generic).wav"))
    // },
    // "UndoAction": {
    //     "volume": 0.85,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX TEXT WINDOW CLOSE 2.wav"))
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UndoAction.wav"))
    // },





    // "Music:Town": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Sewer_Town_Master.ogg")),
    //     "kill": {"label": "music"},
    // },
    // "Music:Combat:A": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "type": "simultaneously",
    //     "hasIntensity": true,
    //     "loop": true,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop1_L1.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop1_L2.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop1_L3.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop1_L4.ogg")),
    //     ],
    //     "kill": {"label": "music"},
    //     "volume": 0,
    // },
    // "Music:Combat:B": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "type": "simultaneously",
    //     "hasIntensity": true,
    //     "loop": true,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop2_L1.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop2_L2.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop2_L3.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop2_L4.ogg")),
    //     ],
    //     "kill": {"label": "music"},
    // },
    // "Music:Combat:C": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "type": "simultaneously",
    //     "hasIntensity": true,
    //     "loop": true,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop3_L1.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop3_L2.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop3_L3.ogg")),
    //     ],
    //     "kill": {"label": "music"},
    // },
    // "Music:Combat:D": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     "loop": true,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop3_Transition.ogg")),
    //     "kill": {"label": "music"},
    // },
    // "Music:Combat:E": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "type": "simultaneously",
    //     "hasIntensity": true,
    //     "loop": true,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop4_L1.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop4_L2.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop4_L3.ogg")),
    //     ],
    //     "kill": {"label": "music"},
    // },
    // "Music:Combat:Done": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Outro.ogg")),
    //     "kill": {"label": "music"},
    // },
    // "Music:Town": {
    //     "volume": 0.37,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Sewer_Town_Master.ogg")),
    //     "kill": {"label": "music"},
    // },
    // "Ambience:General": {
    //     "volume": 0.37,
    //     "label": "ambience",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Wasteland_Ambience_Final.ogg")),
    //     "kill": {"label": "ambience"},
    // },
    // "Ambience:Town": {
    //     "volume": 0.37,
    //     "label": "ambience",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Town_Ambience.ogg")),
    //     "kill": {"label": "ambience"},
    // },
    //
    // // "Unit:Attacked": { // not currently used
    // //     "volume": 0.33,
    // //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Defend.ogg")), // bad
    // // },
    // "Unit:Attack:Melee": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Attack_Melee.ogg")), // bad
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Attack_Melee.ogg")),
    // },
    // "Unit:Attack:Ranged": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Attack_Ranged.ogg")), // bad
    // },
    // "Unit:Garden": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Garden.ogg")),
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Garden_FInal.ogg")), // bad
    // },
    // "Unit:Harvest": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Crop_Harvest.ogg")),
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Harvest.ogg")), // bad
    // },
    // "Unit:Pig": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/cry1.wav")),
    // },
    // "Unit:Chicken": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/cry3.wav")),
    // },
    // "Unit:Sheep": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/cry2.wav")),
    // },
    // "Unit:Death": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Death.ogg")),
    // },


    // given, but not needed lol
    // source/assets/audio/apocalypse-tactics/fmod/Assets/UI_Text.ogg
    // source/assets/audio/apocalypse-tactics/fmod/Assets/UI_Select.ogg

    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Start.ogg")),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_1.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_2.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_3.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_4.ogg")),
    //         new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_5.ogg")),
    //     ]
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Cancel.ogg")),
    // },
    // "UndoAction": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Player_Undo.ogg")),
    // },
    // "EndTurn": {
    //     "volume": 0.5,
    //     "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Player_EndTurn.ogg")),
    // },



    // // LEVIATHAN TACTICS
    // "Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Player_Start.mp3")),
    // },
    // "Music:Opening": {
    //     "volume": 0.33,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/music/title.mp3")),
    //     "kill": {"label": "music"},
    // },
    // "Music:Battle": {
    //     "volume": 0.33,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/music/battle.mp3")),
    //     "kill": {"label": "music"},
    // },
    // "Music:Success": {
    //     "volume": 0.33,
    //     "label": "music",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/music/success.mp3")),
    //     "kill": {"label": "music"},
    // },
    // "Music:Failure": {
    //     "volume": 0.33,
    //     "label": "music",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/music/failure.mp3")),
    //     "kill": {"label": "music"},
    // },
    // "Ambience:General": {
    //     "volume": 0.5,
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Ambience_General.mp3")),
    // },
    // "Unit:Move:Infantry": {
    //     "volume": 0.25,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Move_01.mp3")),
    //         new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Move_02.mp3")),
    //         new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Move_03.mp3")),
    //         new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Move_04.mp3")),
    //     ]
    // },
    // "Unit:Death": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Death_Enemy.mp3")),
    // },
    // "Unit:Death:Player": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Death_Player.mp3")),
    // },
    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Selection_Start.mp3")),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Selection_Move.mp3")),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Selection_Cancel.mp3")),
    // },
    // "Selection:Finish": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Selection_Finish.mp3")),
    // },
    // "EndTurn": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_end_Turn.mp3")),
    // },
    // "UndoAction": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Player_Undo.mp3")),
    // },
    // "Unit:Dragoon:Jump": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Dragoon_Jump.mp3")),
    // },
    // "Unit:Dragoon:Land": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Dragoon_Land.mp3")),
    // },
    // "Unit:Dragoon:Stab": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Dragoon_Stab.mp3")),
    // },
    // "Unit:Samurai:Attack": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Fiego_Attack.mp3")),
    // },
    // "Unit:Samurai:Sheath": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Fiego_Sheath.mp3")),
    // },
    // "Unit:Samurai:Reel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Fiego_Reel_Attack.mp3")),
    // },
    // "Unit:Smallfry:Attack": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Enemy_Hit.mp3")),
    // },
    // // FIRE EMBLEM GBA
    // // FIRE EMBLEM GBA
    // "Unit:Move:Armored": {
    //     "volume": 0.33,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Armor1.ogg")),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Armor2.ogg")),
    //     ]
    // },
    // "Unit:Move:Horse": {
    //     "volume": 0.33,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Mounted1.ogg")),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Mounted2.ogg")),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Mounted3.ogg")),
    //     ]
    // },
    // "Unit:Move:Infantry": {
    //     "volume": 0.33,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Infantry1.ogg")),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Infantry2.ogg")),
    //     ]
    // },
    // "Unit:Move:Pegasus": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Flier.ogg")),
    // },
    // "Unit:Move:Wyvern": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_FDragon.ogg")),
    // },
    "Unit:Attack": {
        "volume": 0.33,
        "type": "once:randomly",
        "audio": [
            new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing1.ogg")),
            new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing2.ogg")),
            new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing3.ogg")),
            new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing4.ogg")),
            new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing5.ogg")),
            new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing6.ogg")),
        ]
    },
    "Unit:Attack:Hit": {
        "volume": 0.33,
        "type": "once:randomly",
        "audio": [
            new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit1.ogg")),
            new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit2.ogg")),
            new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit3.ogg")),
        ]
    },
    "Unit:Attack:Miss": {
        "volume": 0.33,
        "type": "once:randomly",
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Miss.ogg")),
    },
    "Unit:Attack:Utility": {
        "volume": 0.33,
        "type": "once:randomly",
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Sword_Draw.ogg")),
    },
    "Unit:Death": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Death.ogg")),
    },
    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Open.ogg")),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Cursor_Move.ogg")),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Cancel.ogg")),
    // },
    // "Selection:Finish": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Unit_Select.ogg")),
    // },
    // "UndoAction": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Confirm.ogg")),
    // },
    // "EndTurn": {
    //     "volume": 0.5,
    // },

    // If you're looking for good sounds, start here.
    // // FIRE EMBLEM HEROES
    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/map_4.wav")),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/map_5.wav")),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/embedded_6.wav")),
    // },
    // "Selection:Finish": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/map_3.wav")),
    // },
    // "EndTurn": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/embedded_5.wav")),
    // },
    // "UndoAction": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/embedded_4.wav")),
    // },
    // "Unit:Attack:Hit": {
    //     "volume": 0.5,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/btl_blow1.wav")),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/btl_blow2.wav")),
    //     ]
    // },
    // "Unit:Attack:Miss": {
    //     "volume": 0.5,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/Attack Miss 1.wav")),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/Attack Miss 2.wav")),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/Attack Miss 3.wav")),
    //     ]
    // },
    // "Unit:Heal": {
    //     "volume": 0.5,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/btl_cure1.wav")),
    // },
    // "Unit:Death": {
    //     "volume": 0.5,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/btl_dead1.wav")),
    // },
    // "Unit:Move": {
    //     "volume": 0.5,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/fs_normal_sand_1.wav")),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/fs_normal_sand_2.wav")),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/fs_normal_sand_3.wav")),
    //     ]
    // },


    // BOMBER SFXR
    // "Unit:Move": {
    //     "volume": 0.5,
    //     "type": "once:randomly",
    //     "audio": [
    //         // new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/Attack Hit 4.wav")),
    //     ]
    // },
    // "Unit:Shotgun:Load": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/archive/chkchk.wav"))
    // },
    // "Unit:PushGun:Shoot": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/PUSH GUN.wav")),
    // },
    // "Unit:PullGun:Shoot": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/PULL GUN.wav")),
    // },
    // "Unit:Shotgun:Shoot": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/BURST GUN 1.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/BURST GUN 2.wav")),
    //     ]
    // },
    // "Unit:Throw": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/BOMB THROW.wav")),
    // },
    // "Unit:Move": {
    //     "volume": 1,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 1.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 2.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 3.wav")),
    //     ]
    // },
    // "Bomb:Explode": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 1.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 2.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 3.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 4.wav")),
    //     ]
    // },
    // "Music:1": {
    //     "type": "march",
    //     "volume": 0.37,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN1.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN1 LOOP.wav")),
    //     ]
    // },
    // "Music:2": {
    //     "type": "march",
    //     "volume": 0.7,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN2.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN2 LOOP.wav")),
    //     ],
    //     // "killTrigger": "Music:1",
    // },
    // "Music:3": {
    //     "type": "march",
    //     "volume": 0.7,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN3.wav")),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN3 LOOP.wav")),
    //     ],
    //     // "killTrigger": "Music:1",
    // },
    // "Selection:Start": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Select.wav")),
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/SELECT UNIT.wav")),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UnSelect.wav")),
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CANCEL.wav")),
    // },
    // "Selection:Finish": {
    //     "volume": 0.85,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/PerformAction.wav")),
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CONFIRM.wav")),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Hover.wav")),
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CURSOR MOVEMENT.wav")),
    // },
    // "EndTurn": {
    //     "volume": 0.85,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CONFIRM (Generic).wav"))
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/END TURN.wav")),
    // },
    // "UndoAction": {
    //     "volume": 0.85,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX TEXT WINDOW CLOSE 2.wav"))
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UndoAction.wav"))
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/UNDO.wav")),
    // },


    // "Unit:Death": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CANNOT CONFIRM.wav"))
    // },
    // "Unit:Death:Falling": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Falling Off Map.wav"))
    // },
    // "Unit:Escape": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Escape Map Zipline.wav"))
    // },
    // "Flipper:Swing": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Bo Staff Flip.wav"))
    //     ]
    // },
    // "Pusher:Swing": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 1.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 2.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 3.wav")),
    //     ]
    // },
    // "Robot:Swing": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Robot Sounds.wav"))
    //     ]
    // },
    // "Puller:Throw": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Throw.wav"))
    // },
    // "Puller:Pull": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Pull In.wav"))
    // },
    // "Aoe-er:Shoot": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Fire.wav"))
    // },
    // "Aoe-er:Explosion": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav")),
    //     ]
    // },
    // "Victory": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Victory Theme 1.wav"))
    //     ],
    // },
    // "Victory:Final": {
    //     "volume": 1,
    //     "type": "march",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Victory Theme ENDGAME.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Full.wav")),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Loop.wav")),
    //     ],
    //     "killTrigger": "Music:Final",
    // }
    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Select.wav")),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UnSelect.wav")),
    // },
    // "Selection:Finish": {
    //     "volume": 0.85,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/PerformAction.wav")),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Hover.wav")),
    // },
    // "EndTurn": {
    //     "volume": 0.85,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CONFIRM (Generic).wav"))
    // },
    // "UndoAction": {
    //     "volume": 0.85,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX TEXT WINDOW CLOSE 2.wav"))
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UndoAction.wav"))
    // },
}

export default audiotriggers
